<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-outer" }, [
    _c("div", { staticClass: "step-variation" }, [
      _c(
        "div",
        { staticClass: "stepper-main" },
        _vm._l(_vm.steps, function (step, index) {
          return _c(
            "div",
            {
              key: step.status ? step.status + index : index,
              staticClass: "step-outer",
              class: step.status,
              style: {
                "max-width": 100 / _vm.steps.length + "%",
                "min-width": 100 / _vm.steps.length + "%",
              },
            },
            [
              !step.status
                ? _c("div", { staticClass: "step-number" }, [
                    _vm._v(" " + _vm._s(index + 1) + " "),
                  ])
                : _c(
                    "div",
                    { staticClass: "step-number" },
                    [
                      step.status.toLowerCase() === "success"
                        ? _c("Success")
                        : _vm._e(),
                      step.status.toLowerCase() === "pending"
                        ? _c("Pending")
                        : _vm._e(),
                      step.status.toLowerCase() === "failed"
                        ? _c("Failed")
                        : _vm._e(),
                    ],
                    1
                  ),
              _c("div", { staticClass: "step-title" }, [
                _vm._v(_vm._s(step.title)),
              ]),
              _c("div", { staticClass: "step-desc" }, [
                _vm._v(" " + _vm._s(step.text) + " "),
              ]),
              step.remark
                ? _c(
                    "div",
                    {
                      staticClass: "step-desc",
                      class: {
                        "text-primary":
                          step.status &&
                          step.status.toLowerCase() === "success",
                        "text-warning":
                          step.status &&
                          step.status.toLowerCase() === "pending",
                        "text-danger":
                          step.status && step.status.toLowerCase() === "failed",
                      },
                    },
                    [_vm._v(" " + _vm._s(step.remark) + " ")]
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/Stepper.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_check_svg from '@/assets/rashi-coin/check.svg';
import assets_rashi_coin_ex_svg from '@/assets/rashi-coin/ex.svg';
import assets_rashi_coin_cross_svg from '@/assets/rashi-coin/cross.svg';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





export default ({
  render,
  staticRenderFns,
  components: {
    BButton: bootstrapvue["BButton"],
    Failed: assets_rashi_coin_cross_svg,
    Pending: assets_rashi_coin_ex_svg,
    Success: assets_rashi_coin_check_svg
  },
  props: ["steps"]
});

//# sourceURL=webpack:///./src/layouts/components/Stepper.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

